const failedAvatarSrcs = new Set<string>();

/**
 * Remembers, for the rest of the session, a photo URL that failed to load, so
 * later avatars skip the request and show their initial straight away.
 */
export const rememberFailedAvatarSrc = (src: string) => {
    failedAvatarSrcs.add(src);
};

/** Whether a photo URL already failed to load this session. */
export const hasAvatarSrcFailed = (src: string) => failedAvatarSrcs.has(src);
